/**
 * abilityVfxSpecs — Pure descriptors keyed by AbilitySpec.vfxId (AB-03).
 * No THREE; presentation painters read these via abilityVfx.js.
 */

export const ABILITY_VFX_SPECS = {
  ashe_q: {
    id: 'ashe_q',
    kind: 'aura',
    color: 0x38bdf8,
    scale: 1.45,
    shape: 'frost_aura',
    duration: 6,
    follow: true
  },
  ashe_w: { id: 'ashe_w', kind: 'projectile', color: 0x7dd3fc, scale: 0.9, shape: 'volley_arrow' },
  ashe_e: { id: 'ashe_e', kind: 'projectile', color: 0xf1f5f9, scale: 1.15, shape: 'hawkshot' },
  ashe_r: { id: 'ashe_r', kind: 'projectile', color: 0x67e8f9, scale: 1.85, shape: 'crystal_arrow' },
  garen_q: {
    id: 'garen_q',
    kind: 'aura',
    color: 0xfacc15,
    scale: 1.2,
    shape: 'decisive_strike',
    duration: 4.5,
    follow: true
  },
  garen_w: {
    id: 'garen_w',
    kind: 'aura',
    color: 0xfef3c7,
    scale: 1.4,
    shape: 'courage',
    duration: 4,
    follow: true
  },
  garen_e: {
    id: 'garen_e',
    kind: 'aura',
    color: 0xfbbf24,
    scale: 1.85,
    shape: 'judgment',
    duration: 3,
    follow: true
  },
  garen_r: {
    id: 'garen_r',
    kind: 'burst',
    color: 0xfde047,
    scale: 1.5,
    shape: 'demacian_justice',
    duration: 0.55
  },
  ryze_q: { id: 'ryze_q', kind: 'projectile', color: 0x818cf8, scale: 1.0, shape: 'overload' },
  ryze_w: {
    id: 'ryze_w',
    kind: 'burst',
    color: 0x818cf8,
    scale: 1.1,
    shape: 'rune_cage',
    duration: 0.6
  },
  ryze_e: {
    id: 'ryze_e',
    kind: 'burst',
    color: 0x6366f1,
    scale: 1.0,
    shape: 'flux_orb',
    duration: 0.5
  },
  ryze_r: {
    id: 'ryze_r',
    kind: 'aura',
    color: 0x312e81,
    scale: 1.55,
    shape: 'ring',
    duration: 6,
    follow: true
  },
  annie_q: {
    id: 'annie_q',
    kind: 'burst',
    color: 0xfb923c,
    scale: 0.95,
    shape: 'disintegrate',
    duration: 0.45
  },
  annie_w: { id: 'annie_w', kind: 'projectile', color: 0xea580c, scale: 0.95, shape: 'incinerate' },
  annie_e: {
    id: 'annie_e',
    kind: 'aura',
    color: 0xf97316,
    scale: 1.35,
    shape: 'molten_shield',
    duration: 5,
    follow: true
  },
  annie_r: {
    id: 'annie_r',
    kind: 'ground',
    color: 0xb91c1c,
    scale: 2.4,
    shape: 'tibbers_summon',
    duration: 0.85
  },
  sivir_q: {
    id: 'sivir_q',
    kind: 'projectile',
    color: 0xf59e0b,
    scale: 1.15,
    shape: 'boomerang_blade'
  },
  sivir_w: {
    id: 'sivir_w',
    kind: 'aura',
    color: 0xfcd34d,
    scale: 1.35,
    shape: 'ricochet_spark',
    duration: 3.5,
    follow: true
  },
  sivir_e: {
    id: 'sivir_e',
    kind: 'aura',
    color: 0x38bdf8,
    scale: 1.45,
    shape: 'spell_shield',
    duration: 1.5,
    follow: true
  },
  sivir_r: {
    id: 'sivir_r',
    kind: 'aura',
    color: 0xca8a04,
    scale: 1.85,
    shape: 'on_the_hunt',
    duration: 8,
    follow: true
  },
  darius_q: {
    id: 'darius_q',
    kind: 'ground',
    color: 0xb91c1c,
    scale: 2.0,
    shape: 'decimate',
    duration: 0.55
  },
  darius_w: {
    id: 'darius_w',
    kind: 'aura',
    color: 0xdc2626,
    scale: 1.25,
    shape: 'crippling_strike',
    duration: 3.5,
    follow: true
  },
  darius_e: {
    id: 'darius_e',
    kind: 'burst',
    color: 0x7f1d1d,
    scale: 1.4,
    shape: 'apprehend',
    duration: 0.5
  },
  darius_r: {
    id: 'darius_r',
    kind: 'burst',
    color: 0xef4444,
    scale: 1.65,
    shape: 'noxian_guillotine',
    duration: 0.6
  },
  sett_q: {
    id: 'sett_q',
    kind: 'aura',
    color: 0xf97316,
    scale: 1.3,
    shape: 'knuckle_down',
    duration: 4,
    follow: true
  },
  sett_w: {
    id: 'sett_w',
    kind: 'aura',
    color: 0xea580c,
    scale: 1.2,
    shape: 'haymaker',
    duration: 3,
    follow: true
  },
  sett_e: {
    id: 'sett_e',
    kind: 'burst',
    color: 0xfb923c,
    scale: 1.5,
    shape: 'facebreaker',
    duration: 0.45
  },
  sett_r: {
    id: 'sett_r',
    kind: 'ground',
    color: 0xc2410c,
    scale: 2.2,
    shape: 'show_stopper',
    duration: 0.75
  },
  jax_q: {
    id: 'jax_q',
    kind: 'burst',
    color: 0xa855f7,
    scale: 1.15,
    shape: 'leap_strike',
    duration: 0.4
  },
  jax_w: {
    id: 'jax_w',
    kind: 'aura',
    color: 0xf59e0b,
    scale: 1.2,
    shape: 'empower',
    duration: 3,
    follow: true
  },
  jax_e: {
    id: 'jax_e',
    kind: 'aura',
    color: 0x7c3aed,
    scale: 1.55,
    shape: 'counter_strike',
    duration: 2,
    follow: true
  },
  jax_r: {
    id: 'jax_r',
    kind: 'aura',
    color: 0xeab308,
    scale: 1.7,
    shape: 'grandmaster_arms',
    duration: 8,
    follow: true
  },
  lux_q: {
    id: 'lux_q',
    kind: 'projectile',
    color: 0x38bdf8,
    scale: 1.15,
    shape: 'light_binding'
  },
  lux_w: {
    id: 'lux_w',
    kind: 'projectile',
    color: 0x7dd3fc,
    scale: 1.35,
    shape: 'prismatic_barrier',
    duration: 1.2,
    follow: false
  },
  lux_e: {
    id: 'lux_e',
    kind: 'ground',
    color: 0x22d3ee,
    scale: 1.7,
    shape: 'lucent_singularity',
    duration: 5
  },
  lux_r: {
    id: 'lux_r',
    kind: 'burst',
    color: 0xfde047,
    scale: 1.95,
    shape: 'final_spark',
    duration: 0.55
  },
  brand_q: {
    id: 'brand_q',
    kind: 'burst',
    color: 0xea580c,
    scale: 1.1,
    shape: 'sear',
    duration: 0.4
  },
  brand_w: {
    id: 'brand_w',
    kind: 'ground',
    color: 0xdc2626,
    scale: 1.8,
    shape: 'pillar_of_flame',
    duration: 0.65
  },
  brand_e: {
    id: 'brand_e',
    kind: 'burst',
    color: 0xf97316,
    scale: 1.25,
    shape: 'conflagration',
    duration: 0.45,
    follow: true
  },
  brand_r: {
    id: 'brand_r',
    kind: 'burst',
    color: 0xb91c1c,
    scale: 1.7,
    shape: 'pyroclasm',
    duration: 0.7
  },
  veigar_q: {
    id: 'veigar_q',
    kind: 'projectile',
    color: 0x7c3aed,
    scale: 1.05,
    shape: 'baleful_strike'
  },
  veigar_w: {
    id: 'veigar_w',
    kind: 'ground',
    color: 0x5b21b6,
    scale: 1.6,
    shape: 'dark_matter',
    duration: 1.25
  },
  veigar_e: {
    id: 'veigar_e',
    kind: 'ground',
    color: 0x4c1d95,
    scale: 1.7,
    shape: 'event_horizon',
    duration: 3.5
  },
  veigar_r: {
    id: 'veigar_r',
    kind: 'burst',
    color: 0x6d28d9,
    scale: 1.55,
    shape: 'primordial_burst',
    duration: 0.55
  },
  soraka_q: {
    id: 'soraka_q',
    kind: 'ground',
    color: 0xfde047,
    scale: 1.55,
    shape: 'starcall',
    duration: 0.55
  },
  soraka_w: {
    id: 'soraka_w',
    kind: 'burst',
    color: 0xf472b6,
    scale: 1.25,
    shape: 'astral_infusion',
    duration: 0.5,
    follow: true
  },
  soraka_e: {
    id: 'soraka_e',
    kind: 'ground',
    color: 0xa78bfa,
    scale: 1.65,
    shape: 'equinox',
    duration: 0.65
  },
  soraka_r: {
    id: 'soraka_r',
    kind: 'aura',
    color: 0xfacc15,
    scale: 1.85,
    shape: 'wish',
    duration: 0.8,
    follow: true
  },
  lulu_q: {
    id: 'lulu_q',
    kind: 'projectile',
    color: 0xf0abfc,
    scale: 1.15,
    shape: 'glitterlance'
  },
  lulu_w: {
    id: 'lulu_w',
    kind: 'aura',
    color: 0xe879f9,
    scale: 1.35,
    shape: 'whimsy',
    duration: 2.5,
    follow: true
  },
  lulu_e: {
    id: 'lulu_e',
    kind: 'burst',
    color: 0x34d399,
    scale: 1.25,
    shape: 'help_pix',
    duration: 0.5,
    follow: true
  },
  lulu_r: {
    id: 'lulu_r',
    kind: 'burst',
    color: 0x22c55e,
    scale: 1.75,
    shape: 'wild_growth',
    duration: 0.7,
    follow: true
  },
  nami_q: {
    id: 'nami_q',
    kind: 'ground',
    color: 0x22d3ee,
    scale: 1.5,
    shape: 'aqua_prison',
    duration: 0.6
  },
  nami_w: {
    id: 'nami_w',
    kind: 'burst',
    color: 0x14b8a6,
    scale: 1.2,
    shape: 'ebb_and_flow',
    duration: 0.5
  },
  nami_e: {
    id: 'nami_e',
    kind: 'aura',
    color: 0x38bdf8,
    scale: 1.3,
    shape: 'tidecaller_blessing',
    duration: 2.2,
    follow: true
  },
  nami_r: {
    id: 'nami_r',
    kind: 'projectile',
    color: 0x0369a1,
    scale: 1.6,
    shape: 'tidal_wave'
  },
  ezreal_q: {
    id: 'ezreal_q',
    kind: 'projectile',
    color: 0x38bdf8,
    scale: 1.05,
    shape: 'mystic_shot'
  },
  ezreal_w: {
    id: 'ezreal_w',
    kind: 'projectile',
    color: 0xfacc15,
    scale: 1.25,
    shape: 'essence_flux',
    duration: 1.0,
    follow: false
  },
  ezreal_e: {
    id: 'ezreal_e',
    kind: 'aura',
    color: 0xa78bfa,
    scale: 1.2,
    shape: 'arcane_shift',
    duration: 0.55,
    follow: true
  },
  ezreal_r: {
    id: 'ezreal_r',
    kind: 'projectile',
    color: 0x0ea5e9,
    scale: 1.7,
    shape: 'trueshot_barrage'
  },
  caitlyn_q: {
    id: 'caitlyn_q',
    kind: 'projectile',
    color: 0x94a3b8,
    scale: 1.15,
    shape: 'piltover_peacemaker'
  },
  caitlyn_w: {
    id: 'caitlyn_w',
    kind: 'ground',
    color: 0xf59e0b,
    scale: 1.4,
    shape: 'yordle_snap_trap',
    duration: 30
  },
  caitlyn_e: {
    id: 'caitlyn_e',
    kind: 'projectile',
    color: 0x64748b,
    scale: 1.05,
    shape: 'caliber_net'
  },
  caitlyn_r: {
    id: 'caitlyn_r',
    kind: 'aura',
    color: 0xef4444,
    scale: 1.55,
    shape: 'ace_in_the_hole',
    duration: 1.2,
    follow: true
  },
  zed_q: {
    id: 'zed_q',
    kind: 'projectile',
    color: 0x334155,
    scale: 1.15,
    shape: 'razor_shuriken'
  },
  zed_w: {
    id: 'zed_w',
    kind: 'aura',
    color: 0x475569,
    scale: 1.3,
    shape: 'living_shadow',
    duration: 2.0,
    follow: true
  },
  zed_e: {
    id: 'zed_e',
    kind: 'burst',
    color: 0x64748b,
    scale: 1.35,
    shape: 'shadow_slash',
    duration: 0.45,
    follow: true
  },
  zed_r: {
    id: 'zed_r',
    kind: 'burst',
    color: 0xdc2626,
    scale: 1.45,
    shape: 'death_mark',
    duration: 0.6
  },
  katarina_q: {
    id: 'katarina_q',
    kind: 'projectile',
    color: 0xf87171,
    scale: 1.1,
    shape: 'bouncing_blade'
  },
  katarina_w: {
    id: 'katarina_w',
    kind: 'aura',
    color: 0xef4444,
    scale: 1.25,
    shape: 'preparation',
    duration: 1.25,
    follow: true
  },
  katarina_e: {
    id: 'katarina_e',
    kind: 'aura',
    color: 0xfbbf24,
    scale: 1.2,
    shape: 'shunpo',
    duration: 0.4,
    follow: true
  },
  katarina_r: {
    id: 'katarina_r',
    kind: 'aura',
    color: 0xb91c1c,
    scale: 1.65,
    shape: 'death_lotus',
    duration: 2.5,
    follow: true
  },
  yasuo_q: {
    id: 'yasuo_q',
    kind: 'projectile',
    color: 0x93c5fd,
    scale: 1.0,
    shape: 'steel_tempest'
  },
  yasuo_w: {
    id: 'yasuo_w',
    kind: 'aura',
    color: 0xbae6fd,
    scale: 1.25,
    shape: 'wind_wall',
    duration: 4.0,
    follow: true
  },
  yasuo_e: {
    id: 'yasuo_e',
    kind: 'aura',
    color: 0x60a5fa,
    scale: 1.1,
    shape: 'sweeping_blade',
    duration: 0.35,
    follow: true
  },
  yasuo_r: {
    id: 'yasuo_r',
    kind: 'burst',
    color: 0x38bdf8,
    scale: 1.45,
    shape: 'last_breath',
    duration: 0.7
  },
  riven_q: {
    id: 'riven_q',
    kind: 'burst',
    color: 0xa78bfa,
    scale: 1.2,
    shape: 'broken_wings',
    duration: 0.4
  },
  riven_w: {
    id: 'riven_w',
    kind: 'aura',
    color: 0xc4b5fd,
    scale: 1.2,
    shape: 'ki_burst',
    duration: 0.75,
    follow: true
  },
  riven_e: {
    id: 'riven_e',
    kind: 'aura',
    color: 0xe9d5ff,
    scale: 1.25,
    shape: 'valor',
    duration: 2.5,
    follow: true
  },
  riven_r: {
    id: 'riven_r',
    kind: 'burst',
    color: 0x8b5cf6,
    scale: 1.4,
    shape: 'blade_of_the_exile',
    duration: 0.65
  },
  irelia_q: {
    id: 'irelia_q',
    kind: 'aura',
    color: 0xf472b6,
    scale: 1.05,
    shape: 'bladesurge',
    duration: 0.35,
    follow: true
  },
  irelia_w: {
    id: 'irelia_w',
    kind: 'aura',
    color: 0xfb7185,
    scale: 1.2,
    shape: 'defiant_dance',
    duration: 1.5,
    follow: true
  },
  irelia_e: {
    id: 'irelia_e',
    kind: 'projectile',
    color: 0xf43f5e,
    scale: 1.05,
    shape: 'flawless_duet'
  },
  irelia_r: {
    id: 'irelia_r',
    kind: 'projectile',
    color: 0xe11d48,
    scale: 1.3,
    shape: 'vivid_blade'
  }
};

export function getAbilityVfxSpec(vfxId) {
  return ABILITY_VFX_SPECS[vfxId] || null;
}
